import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import { unescapeHtmlTags } from '../helpers'

import './header.scss'

@observer
class Header extends Component {
    constructor(props) {
        super(props)
        this.state = { userAccounts: undefined, currentUserEmail: undefined }
        this.formRef = React.createRef()
    }

    async componentDidMount() {
        const { store } = this.props
        const { setShowUserDropdown } = store
        const userRole = R.path(['userData', 'role'], store)
        const currentUserEmail = R.path(['userData', 'email'], store) // getUserEmail()
        if (
            (
                (store.isExploriAdmin() && [100, 110].includes(userRole))
                || R.pathOr(false, ['userData', 'isReseller'], store)
            )
            && !store.isLoginChoose) {
            const userAccountsRes = await store.http.get('/user/accounts')

            const userAccounts = userAccountsRes.accounts
                ? userAccountsRes.accounts
                    .map((ua) => ({ ...ua, clientName: userAccountsRes.clients[ua.clientId] }))
                : undefined
            setShowUserDropdown(true)
            this.setState({ userAccounts, currentUserEmail })
        } else {
            this.setState({ userAccounts: undefined, currentUserEmail })
        }
        store.getServiceStatusHeaderMessage()
    }

    renderUserAccountOption = () => {
        const { userAccounts, currentUserEmail } = this.state
        const { store } = this.props
        const { tokenData } = store

        const url = process.env.USE_NEW_LOGIN
            ? '/api/login/switchLoggedInUser'
            : '/login/switchLoggedInUser'

        return (
            <form ref={this.formRef} action={url} method="post" className="select-form">
                <input name="email" type="text" hidden value={currentUserEmail} />
                <input name="csrf" type="text" hidden value={store.csrf} />
                <select name="userid" className="client-select" onChange={this.changeUser}>
                    {userAccounts.map((ua) => (
                        <option
                            value={ua.userId}
                            selected={ua.userId === tokenData.userId}
                        >
                            {`${unescapeHtmlTags(ua.clientName)} [${ua.clientId}] [${store.getUserRole(ua.role)}_USER] - ${ua.firstName} ${ua.lastName}`}
                        </option>
                    ))}
                </select>
            </form>
        )
    }

    changeUser = () => {
        this.formRef.current.submit()
    }

    renderBreadcrumb() {
        const { store: { breadcrumps } } = this.props
        if (breadcrumps.length > 0) {
            const breadcrumpsCopy = [...breadcrumps]
            const lastCrump = breadcrumpsCopy.pop()
            return (
                <Fragment>
                    {breadcrumpsCopy.length > 0 && (
                        <li>
                            <i className="fa-regular fa-chevron-right" />
                            <i className="ellipsis-icon fa-regular fa-ellipsis">
                                <div className="float-card">
                                    {breadcrumpsCopy.map((path, index) => {
                                        const id = `breadcrump-${index}`
                                        return (
                                            <li key={id}>
                                                <a href={path.url}>{path.title}</a>
                                            </li>
                                        )
                                    })}
                                </div>
                            </i>
                        </li>
                    )}
                    <li>
                        <i className="fa-regular fa-chevron-right" />
                        <a href={lastCrump.url}>{lastCrump.title}</a>
                    </li>
                </Fragment>
            )
        }
        return null
    }

    renderShowDropdown = () => {
        const { store } = this.props
        const { setShowUserDropdown, showUserDropdown } = store

        return (
            <button
                className="show-dropdown"
                type="button"
                onClick={() => setShowUserDropdown(!showUserDropdown)}
            />
        )
    }

    render() {
        const { userAccounts } = this.state
        const { store } = this.props
        const { showUserDropdown } = store
        return (
            <div id="header">
                <div id="logo">
                    <a href="/">
                        <img src={`${process.env.CDN_URL}/images/logo_explori.png`} alt="Explori Logo" />
                    </a>
                </div>
                <div id="admin-dropdown">
                    {userAccounts && showUserDropdown
                        ? this.renderUserAccountOption()
                        : null}
                    {userAccounts ? this.renderShowDropdown() : null}
                    {!showUserDropdown ? <span id="serviceStatus"><p className={`${store.serviceStatus.style} headerMessage`} dangerouslySetInnerHTML={{ __html: store.serviceStatus.message }} /></span> : null}
                </div>
                <div id="breadcrump">
                    {
                        !store.isLoginChoose
                            ? (
                                <ul>
                                    <li>
                                        <a href="/">{i18n.t('breadcrumb_home')}</a>
                                    </li>
                                    {this.renderBreadcrumb()}
                                </ul>
                            ) : null
                    }
                </div>
            </div>
        )
    }
}

export default Header
